export default __webpack_public_path__ + "static/media/separation.f4afe1e2.svg";